import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { FormData } from "components/onboarding/CreateAccountForm";
import { useOpenApi } from "lib/openApiContext";
import { EventNames, logUserConversion, useTracking } from "lib/tracking";

type useCreateAccountParams = {
  formState: FormData;
  utmParams: object | null;
  seoParams: object | null;
};

export function useCreateAccount(
  options?: UseMutationOptions<string, unknown, useCreateAccountParams, unknown>,
) {
  const api = useOpenApi();
  const { logEvent } = useTracking();

  return useMutation(
    async ({ formState, utmParams, seoParams }: useCreateAccountParams) => {
      const response = await api.createAccount({
        createAccountRequest: {
          firstName: formState.firstName,
          lastName: formState.lastName,
          companyName: formState.companyName,
          jobTitle: formState.jobTitle,
          utmParams: utmParams,
          seoParams: seoParams,
        },
      });
      return response.userGuid;
    },
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        logEvent(EventNames.userAccountCreated, {
          Email: variables.formState.email,
          "First name": variables.formState.firstName,
          "Last name": variables.formState.lastName,
          "Company name": variables.formState.companyName,
          "Job title": variables.formState.jobTitle,
        });
        await logUserConversion();
        await options?.onSuccess?.(data, variables, context);
      },
    },
  );
}
